<template>
  <section id="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div  class="box box-primary" id="filterSection">  <!-- style="position:fixed;z-index:10" -->
          <div class="box-body">
            <div class="box no-border">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Payment Channel:</label>
                  <select v-model="formData.paymentChannel" class="form-control" @change="onChangePaymentChannel">
                    <option v-for="(row, i) in paymentChannels" v-bind:key="i" v-bind:value="row.id">
                      {{ row.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Payment Date:</label>
                  <div class="input-group">
                    <datepicker name="paymentDateFrom" :value=formData.paymentDateFrom :format=DATE_FORMAT :input-attr="{ 'id': 'paymentDateFrom' }" :input-style="{ 'width': '100%' }"></datepicker>
                    <!-- <label>to</label>
                    <datepicker name="paymentDateTo" @change="onChangePaymentDate" :value=formData.paymentDateTo :format=DATE_FORMAT :input-attr="{ 'id': 'paymentDateTo' }" :input-style="{ 'width': '100%' }"></datepicker> -->
                    <!-- <button @click="onSearch()" class="btn btn-warning" style="margin-left: 10px;">Search</button> -->
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Booking Date:</label>
                  <select v-model="formData.bookingDate" class="form-control">
                    <option value="" selected>Please choose</option>
                    <option v-for="(row, i) in bookingDates" v-bind:key="i" v-bind:value="row">
                      {{ row }}
                    </option>
                  </select> 
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Bank:</label>
                  <select v-model="formData.bank" class="form-control">
                    <option value="" selected>Please choose</option>
                    <option v-for="(row, i) in banks" v-bind:key="i" v-bind:value="row">
                      {{ row }}
                    </option>
                  </select>                  
                </div>
              </div>
              <div class="col-md-3">
                <span class="label label-success pull-right"><h4>{{formData.totalAmountDisplay}}</h4></span>
                <button @click="onSearch()" class="btn btn-warning" style="margin-left: 10px;">Search</button>
              </div>                
            </div>
          </div>
        </div>
        <div class="box box-success" id="listData">        
          <div class="box-header with-border">
            <h3 class="box-title">Open Payments</h3>
            <!-- <span class="label label-success pull-right"><h4>{{formData.totalAmountDisplay}}</h4></span> -->
          </div>        
          <div class="box-body no-padding table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="width: 45px;text-align:right;">#</th>
                  <th style="text-align:center;">Action</th>
                  <th style="text-align:center;">Booking Date</th>                  
                  <th style="text-align:left;">Payment ID</th>
                  <th style="text-align:left;">Payment Type</th>
                  <th style="text-align:right;">Total Amount</th>
                  <th style="text-align:right;">Qty</th>
                  <th style="text-align:center;">Process Date</th>
                  <th style="text-align:left;">Bank</th>
                  <th style="text-align:left;">Card Type</th>
                  <th style="text-align:left;">Transaction ID</th>
                  <th style="text-align:left;">Payment Gateway</th>
                  <th style="text-align:left;">Email</th>
                  <th style="text-align:left;">Project</th>                    
                  <th style="text-align:left;">First Name</th>
                  <th style="text-align:left;">Last Name</th>
                  <th style="text-align:left;">Payment Method</th>
                  <th style="text-align:center;">Status</th>
                </tr>
              </thead>
              <tbody style="height: 100px; overflow-y: scroll">
                <tr v-for="(row, i) in listData" v-bind:key="i">
                  <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                  <td style="width:45px;text-align:center;" no-wrap>
                    <input type="checkbox" :id="row.id" :value="row.id" v-model="checkedPayments" @change="onCheckedPayment">
                    <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                      <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                    </a>                   
                  </td>
                  <td style="text-align:center;" nowrap>{{ row.booking_date }}</td>                  
                  <td style="text-align:left;" nowrap>{{ row.id }}</td>
                  <td style="text-align:left;" nowrap>{{ row.payment_type }}</td>
                  <td style="text-align:right;" nowrap>{{ row.total_amount }}</td>
                  <td style="text-align:right;" nowrap>{{ row.quantity }}</td>
                  <td style="text-align:center;" nowrap>{{ row.process_date }}</td>
                  <td style="text-align:left;" nowrap>{{ row.bank }}</td>
                  <td style="text-align:left;" nowrap>{{ row.card_type }}</td>
                  <td style="text-align:left;" nowrap>{{ row.transaction_id }}</td>
                  <td style="text-align:left;" nowrap>{{ row.payment_gateway }}</td>
                  <td style="text-align:left;" nowrap>{{ row.email }}</td>
                  <td style="text-align:left;" nowrap>{{ row.project_name }}</td>
                  <td style="text-align:left;" nowrap>{{ row.first_name }}</td>
                  <td style="text-align:left;" nowrap>{{ row.last_name }}</td>
                  <td style="text-align:left;" nowrap>{{ row.payment_method }}</td>
                  <td style="text-align:center;">
                    <span v-if="row.status == STATUS_PENDING" class="badge bg-red">{{ row.status }}</span>
                    <span v-if="row.status == STATUS_SETTLEMENT" class="badge bg-green">{{ row.status }}</span>
                    <span v-if="row.status == STATUS_CLOSE" class="badge bg-blue">{{ row.status }}</span>
                  </td>
                  <td hidden>{{ row.project_id }}</td>
                  <td hidden>{{ row.company_id }}</td>                    
                </tr>
              </tbody>
            </table>
          </div>
          <div class="box-footer clearfix">
            <div class="form-group">
              <!-- <button class="btn btn-primary pull-right" data-toggle="modal" data-target="#modal-clearing-conf">Clearing</button> -->
              <button class="btn btn-primary pull-right" @click="onShowModalClearing()">Clearing</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row center-block">
      <div class="col-md-3">

      </div>
    </div>  
    <div class="modal fade" id="modal-clearing-conf" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Payment Clearing</h4>
          </div>
          <div class="modal-body">
            <div class="box no-border form-horizontal">
              <div class="form-group">
                <label class="col-sm-4 control-label">Bank</label>
                <div class="col-md-8">
                    <select v-model="formData.bankAccount" class="form-control" @change="onChangeBankAccount">
                      <option v-for="(row, i) in listBankAccounts" v-bind:key="i" v-bind:value="row.id">
                        {{ row.name }}
                      </option>
                    </select>
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Transaction Balance</label>
                <div class="col-md-8">
                  <input type="text" readonly class="form-control" id="inputTransactionBalanceModal" v-model="formData.totalAmountDisplay">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Actual Balance</label>
                <div class="col-md-8">
                  <input @keyup="formattingNumber($event)" type="text" class="form-control" v-model="formData.actualBalance" id="actualBalanceModal" ref="actualBalanceModal">
                </div>                     
              </div>              
              <div class="form-group">
                <label class="col-sm-4 control-label">Different</label>
                <div class="col-md-8">
                  <input type="text" readonly class="form-control" id="inputDifferentModal" v-model="formData.different" ref="different">
                </div>                     
              </div>                                                       
              <div class="form-group">
                <label class="col-sm-4 control-label">Flow Type SAP</label>
                <div class="col-md-8">
                  <input type="text" readonly class="form-control" id="inputFlowTypeSAP" v-model="flowTypeSAP" ref="flowTypeSAP">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Income Account</label>
                <div class="col-md-8">
                  <input type="text" readonly class="form-control" id="inputIncomeAccount" v-model="incomeAccount" ref="incomeAccount">
                </div>                     
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onContinueClearing($event)">Continue</button>
          </div>
        </div>
      </div>
    </div>
  </section> 
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import utilities from '../../utilities'
import axios from 'axios'

const MODE_NONE = 'none'
const MODE_VIEW = 'read'
const STATUS_PENDING = 'pending'
const STATUS_SETTLEMENT = 'settlement'
const STATUS_OPEN = 'open'
const STATUS_CLOSE = 'close'

export default {
  name: 'PaymentClearingForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_SQL: config.dateFormatSql,
      DATETIME_FORMAT_ISO: config.dateTimeFormatSql,
      MODE_NONE: MODE_NONE,
      STATUS_PENDING: STATUS_PENDING,
      STATUS_SETTLEMENT: STATUS_SETTLEMENT,
      STATUS_OPEN: STATUS_OPEN,
      STATUS_CLOSE: STATUS_CLOSE,
      viewMode: MODE_NONE,
      formData: {
        paymentDateFrom: '',
        // paymentDateTo: '',
        paymentChannel: '',
        paymentChannelName: '',
        totalAmount: 0,
        totalAmountDisplay: '0',
        actualBalance: '0',
        different: '0',
        bankAccount: 0,
        bankAccountName: '',
        mitAccount: '',
        currencyName: '',
        bookingDate: '',
        bank: ''
      },
      listData: null,
      listBankAccounts: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1
      },
      originalcallback: '',
      checkedPayments: [],
      projectSelectedDetail: undefined,
      paymentChannels: null,
      banks: null,
      bookingDates: null,
      flowTypeSAP: '',
      incomeAccount: '',
      depositJournal: false
    }
  },
  computed: {
  },
  created() {
    this.formData.paymentDateFrom = moment().format(this.DATE_FORMAT)
    this.formData.paymentDateTo = this.formData.paymentDateFrom
  },
  mounted() {
    this.$root.$on('inquiryPaymentClearingByProject', (projectIds, projectSelectedDetail) => {
      this.projectIds = projectIds
      if (projectSelectedDetail) {
        this.projectSelectedDetail = projectSelectedDetail
      }
      // return this.onSearch()
    })

    if (!this.projectSelectedDetail && this.$store.state.userInfo.projects.length > 0) {
      api
        .request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0], null)
        .then(response => {
          this.projectSelectedDetail = response.data.entity
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    }

    // this.searchBankAccount()
    this.searchPaymentMethod()

    // const filterSection = document.querySelector('#filterSection')
    // const listData = document.querySelector('#listData')
    // listData.style.cssText = 'margin-top:' + (filterSection.offsetHeight + 10) + 'px;'
  },
  methods: {
    onSearch() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose a project that you are authorized', 'info')
        return
      }

      var dateFrom = moment($('#paymentDateFrom').val(), this.DATE_FORMAT)
      dateFrom = moment(dateFrom).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
      dateFrom = this.convertToUtcTime(dateFrom, this.DATETIME_FORMAT_ISO)

      var dateTo = moment($('#paymentDateFrom').val(), this.DATE_FORMAT)
      dateTo = moment(dateTo).format(this.DATE_FORMAT_ISO) + ' 24:00:00'
      dateTo = this.convertToUtcTime(dateTo, this.DATETIME_FORMAT_ISO)

      var whereParams = []
      let index = 0
      whereParams[index] = ['Payment.status', '=', '\'' + this.STATUS_SETTLEMENT + '\'']

      index++
      whereParams[index] = ['Payment.process_date', '>=', '\'' + dateFrom + '\'']
      index++
      whereParams[index] = ['Payment.process_date', '<=', '\'' + dateTo + '\'']
      index++
      whereParams[index] = ['Payment.project_id', '=', this.$store.state.userInfo.projects[0]]
      index++
      whereParams[index] = ['Payment.payment_method', '=', '\'' + this.formData.paymentChannelName + '\'']

      if (this.formData.bookingDate !== '') {
        let bookDate = moment(this.formData.bookingDate, this.DATE_FORMAT)
        bookDate = moment(bookDate).format(this.DATE_FORMAT_SQL).toString()

        index++
        whereParams[index] = ['Payment.booking_date', '=', '\'' + bookDate + '\'']
      }

      if (this.formData.bank !== '') {
        index++
        whereParams[index] = ['Payment.bank', '=', '\'' + this.formData.bank + '\'']
      }

      var whereClause = []
      var j = 0
      for (let i = 0; i < whereParams.length; i++) {
        whereClause[j] = whereParams[i].join(' ')
        j++
      }
      this.inquiryParam.WhereClause = whereClause.join(' AND ')
      this.search()
      this.searchBankAccount()
    },
    search() {
      api
        .request('Payment', 'get', '/api/Payment/InquiryOpenPayment?WhereClause=' + this.inquiryParam.WhereClause)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages

          this.checkedPayments = []
          for (let i = 0; i < this.listData.length; i++) {
            this.checkedPayments.push(this.listData[i].id)
          }
          this.calculateTotalAmount()

          if (this.formData.bookingDate === '' && this.formData.bank === '') {
            this.bookingDates = [...new Set(this.listData.map(x => x.booking_date))]
            this.banks = [...new Set(this.listData.map(x => x.bank))]
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + (error.response !== undefined ? error.response.data.returnMessage.join('<br>') : '')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    searchBankAccount() {
      api
        .request('Account', 'get', '/api/BankAccount/Inquiry?WhereClause=ProjectId=' + this.$store.state.userInfo.projects[0] + '&CurrentPageNumber=1&PageSize=99999')
        .then(response => {
          this.listBankAccounts = response.data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + (error.response !== undefined ? error.response.data.returnMessage.join('<br>') : '')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    searchPaymentMethod() {
      let baseUrl = config.environment === 'Local' ? '/api/Gate' : '/api/Gate/' + this.$store.state.userInfo.projects[0]
      api
        .request('Gate', 'get', baseUrl + '/InquiryPaymentMethod?WhereClause=&PageSize=999&CurrentPageNumber=1&SortDirection=ASC&SortExpression=name', null)
        .then(response => {
          let data = response.data
          this.paymentChannels = data.entity
        })
        .catch(error => {
          let message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    calculateTotalAmount() {
      this.formData.totalAmount = 0
      for (let i = 0; i < this.listData.length; i++) {
        if (this.checkedPayments.find(e => e === this.listData[i].id)) {
          this.formData.totalAmount = this.formData.totalAmount + utilities.ParseNumber(this.listData[i].total_amount)
        }
      }
      this.formData.totalAmountDisplay = utilities.DisplayNumber(this.formData.totalAmount)
      this.calculateDifferent()
    },
    onCheckedPayment() {
      this.calculateTotalAmount()
    },
    formattingNumber(evt) {
      // When the arrow keys are pressed, etc..., abort.
      if ($.inArray(evt.keyCode, [9, 38, 40, 37, 39]) !== -1) {
        return
      }

      var input = this.$refs[evt.target.id].value
      var inputNumber = utilities.ParseNumber(input)
      this.$refs[evt.target.id].value = utilities.DisplayNumber(inputNumber)
      switch (evt.target.id) {
        case 'actualBalanceModal':
          this.formData.actualBalance = utilities.DisplayNumber(inputNumber)
          this.calculateDifferent()
          break
        default:
          break
      }
    },
    calculateDifferent() {
      this.formData.different = utilities.DisplayNumber(utilities.ParseNumber(this.formData.totalAmountDisplay) - utilities.ParseNumber(this.formData.actualBalance))
    },
    onChangeBankAccount() {
      let bankAccountNameSelected = this.listBankAccounts.filter((row) => {
        return row.id === this.formData.bankAccount
      })

      this.formData.bankAccountName = bankAccountNameSelected[0].name
      this.formData.mitAccount = bankAccountNameSelected[0].mitAccount
    },
    onChangePaymentChannel() {
      let paymentChannelSelected = this.paymentChannels.filter((row) => {
        return row.id === this.formData.paymentChannel
      })

      this.formData.paymentChannelName = paymentChannelSelected[0].name
    },
    onContinueClearing() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose a project that you are authorized', 'info')
        return
      }

      if (!this.projectSelectedDetail) {
        SweetAlert.fire('Warning', 'No project selected', 'warning')
        return
      }

      if (this.formData.bankAccount === 0) {
        SweetAlert.fire('Warning', 'Please choose bank account', 'warning')
        return
      }
      this.onChangeBankAccount()

      if (utilities.ParseNumber(this.formData.totalAmountDisplay) === 0) {
        SweetAlert.fire('Warning', 'Total transaction amount is 0', 'warning')
        return
      }

      let different = utilities.ParseNumber(this.formData.different)
      if (different !== 0) {
        SweetAlert.fire('Closing process', 'You have different clearing amount. Please check again. ', 'error')
        return
      }

      // api
      //   .request('Account', 'get', '/api/Company/Inquiry?WhereClause=Id=' + this.projectSelectedDetail.companyId + '&CurrentPageNumber=1&PageSize=999', null)
      //   .then(response => {
      //     let status = response.data.returnStatus ? 'success' : 'error'
      //     let message = response.data.returnMessage.join('<br>')
      //     if (response.data.returnStatus) {
      //       this.projectSelectedDetail.companyName = response.data.entity[0].name
      //       this.projectSelectedDetail.companySAPCode = response.data.entity[0].sapCode
      //       this.clearing()
      //     } else {
      //       SweetAlert.fire(status, message, status)
      //     }
      //   })
      //   .catch(error => {
      //     SweetAlert.fire('Error', error.message, 'error')
      //   })

      // https://www.storyblok.com/tp/how-to-send-multiple-requests-using-axios
      const requestCompany = api.request('Account', 'get', '/api/Company/Inquiry?WhereClause=Id=' + this.projectSelectedDetail.companyId + '&CurrentPageNumber=1&PageSize=999', null)
      const requestCurrency = api.request('Account', 'get', '/api/Currency/Inquiry?WhereClause=Id=' + this.listData[0].currency_id + '&CurrentPageNumber=1&PageSize=999', null)
      axios
        .all([requestCompany, requestCurrency])
        .then(
          axios.spread((...response) => {
            const responseCompany = response[0]
            const responseCurrency = response[1]

            if (responseCompany.data.returnStatus && responseCurrency.data.returnStatus) {
              this.projectSelectedDetail.companyName = responseCompany.data.entity[0].name
              this.projectSelectedDetail.companySAPCode = responseCompany.data.entity[0].sapCode
              this.formData.currencyName = responseCurrency.data.entity[0].name
              this.clearing()
            } else {
              let message = responseCompany.data.returnMessage.join('<br>') + '<br>' + responseCurrency.data.returnMessage.join('<br>')
              SweetAlert.fire('Error', message, 'error')
            }
          })
        )
        .catch(error => {
          SweetAlert.fire('Error', error.message, 'error')
        })
    },
    clearing() {
      var reqData = {
        total_amount: this.formData.totalAmountDisplay,
        currency_id: this.listData[0].currency_id,
        currency_name: this.formData.currencyName,
        payment_channel: this.formData.paymentChannelName,
        bank_account_id: this.formData.bankAccount,
        bank_account_name: this.formData.bankAccountName,
        mit_account: this.formData.mitAccount,
        project_id: this.projectSelectedDetail.id,
        project_name: this.projectSelectedDetail.name,
        project_sap_code: this.projectSelectedDetail.sapCode,
        project_business_area: this.projectSelectedDetail.businessArea,
        project_profit_center: this.projectSelectedDetail.profitCenter,
        company_id: this.projectSelectedDetail.companyId,
        company_name: this.projectSelectedDetail.companyName,
        company_sap_code: this.projectSelectedDetail.companySAPCode,
        payment_id: this.checkedPayments,
        flow_type_sap: this.flowTypeSAP,
        income_account: this.incomeAccount
      }

      var status = ''
      var message = ''
      let me = this
      api
        .request('Payment', 'post', '/api/Payment/Clearing', reqData)
        .then(response => {
          status = response.data.returnStatus ? 'success' : 'error'
          message = response.data.returnMessage.join('<br>')
          SweetAlert.fire('Payment clearing process', message, status)
        })
        .then(response => {
          if (status === 'success') {
            me.$refs.btnCloseModal.click()
            me.onSearch()
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    // refresh() {
    //   $('$paymentDateFrom').val('')
    //   $('$paymentDateTo').val('')
    //   this.formData.paymentDateFrom = moment().format(this.DATE_FORMAT)
    //   this.formData.paymentDateTo = this.formData.paymentDateFrom
    //   this.formData.totalAmount = 0
    //   this.formData.totalAmountDisplay = '0'
    //   this.listData = null
    // }
    onDisplay(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        clearingStatus: false,
        callback: this.$route.name
      }
      this.$router.push({ name: 'Payment', params: params })
    },
    onShowModalClearing() {
      var reqData = {
        payment_id: this.checkedPayments
      }

      let me = this

      api
        .request('Payment', 'post', '/api/Payment/Product', reqData)
        .then(response => {
          if (response.data.returnStatus) {
            me.checkProductCategory(response.data.entity)
          } else {
            SweetAlert.fire('Error', response.data.returnMessage.join('<br>'), 'error')
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },

    checkProductCategory(paymentProducts) {
      let me = this
      me.flowTypeSAP = ''
      me.incomeAccount = ''

      const productIds = []
      for (let i = 0; i < paymentProducts.length; i++) {
        const el = paymentProducts[i]
        productIds.push(el.item_id)
      }

      const reqProduct = api.request('Sales', 'get', '/api/Product/Inquiry?WhereClause=Id IN (' + productIds.join(',') + ')&CurrentPageNumber=1&PageSize=999', null)
      const reqProductCategory = api.request('Sales', 'get', '/api/ProductCategory/InquiryAll', null)
      const reqProductType = api.request('Sales', 'get', '/api/ProductType/InquiryAll', null)
      axios
        .all([reqProduct, reqProductCategory, reqProductType])
        .then(
          axios.spread(async (...response) => {
            const respProduct = response[0]
            const respProductCategory = response[1]
            const respProductType = response[2]
            // const respFlowTypeSAP = response[3]

            if (respProduct.data.returnStatus && respProductCategory.data.returnStatus && respProductType.data.returnStatus) {
              for (let i = 0; i < respProduct.data.entity.length; i++) {
                const el = respProduct.data.entity[i]

                const productCategory = respProductCategory.data.entity.find((productCategory) => {
                  return productCategory.id === el.productCategoryId
                })
                console.log('productCategory', productCategory)
                console.log('project', this.$store.state.userInfo.projects[0])
                const respFlowTypeSAP = await api.request('Sales', 'get', '/api/SAPAccount/Inquiry?WhereClause=ProjectId = ' + this.$store.state.userInfo.projects[0] + ' AND ProductCategoryId = ' + productCategory.id + '&CurrentPageNumber=1&PageSize=999&SortDirection=ASC&SortExpression=Id', null)
                respFlowTypeSAP.data.entity.find((productCategory) => {
                  return productCategory.id === el.productCategoryId
                })
                console.log('flowTypeSAP', respFlowTypeSAP.data.entity)
                let flowTypeSAP = respFlowTypeSAP.data.entity[0].flowTypeSAP
                let incomeAccount = respFlowTypeSAP.data.entity[0].incomeAccount
                if (flowTypeSAP === '' || flowTypeSAP === null) {
                  SweetAlert.fire('Error', 'Please maintain flow type SAP and income account of product category ' + productCategory.name, 'error')
                  return
                }

                if (me.flow_type_sap !== '' && (productCategory.flow_type_sap !== me.flow_type_sap)) {
                  SweetAlert.fire('Error', 'The process can not be continued because selected payments have multiple flow type SAP', 'error')
                  return
                }

                me.flowTypeSAP = flowTypeSAP
                me.incomeAccount = incomeAccount
              }

              window.$('#modal-clearing-conf').modal('show')
            } else {
              let message = respProduct.data.returnMessage.join('<br>') + '<br>' + respProductCategory.data.returnMessage.join('<br>')
              SweetAlert.fire('Error', message, 'error')
            }
          })
        )
        .catch(error => {
          SweetAlert.fire('Error', error.message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PaymentClearing.vue?351de845